import Typography from '@components/common/typography';
import { Icon } from '@components/icons';
import styles from './styles.module.scss';
import { useNavigate } from 'react-router-dom';
import { routes } from '@const/routes';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { pageAnimation } from '@const/animation';
import profileIcon from '@svg/icons/profile.svg';
import notificationsIcon from '@svg/icons/notifications.svg';
import securityIcon from '@svg/icons/security.svg';
import limits from '@svg/icons/limits.svg';
import Button from '@components/common/button';
import { useNavigationContext } from '@hooks/context/useNavigationContext';
import { useLocales } from '@hooks/helpers/useLocales';

const SettingsLayout = () => {
    const { t } = useTranslation('settings');
    const navigate = useNavigate();
    const { handleBack } = useNavigationContext();
    const { submitLocale } = useLocales();

    return (
        <motion.div {...pageAnimation} className={styles.wrapper}>
            <div className={styles.header}>
                <Button
                    className={styles.back}
                    leftIcon="arrow_left"
                    variant="text-gray"
                    onClick={() => handleBack(routes.settings)}>
                    {submitLocale('back')}
                </Button>
                <Typography variant="h4">Settings</Typography>
            </div>
            <div className={styles.actions_wrapper}>
                <div className={styles.tab} onClick={() => navigate(routes.settings_profile)}>
                    <img src={profileIcon} alt="" />
                    <div className={styles.text_wrapper}>
                        <div className={styles.title}>{t('my_profile')}</div>
                        <div className={styles.description}>
                            Manage and update your personal details, contact information, addresses,
                            and general settings
                        </div>
                    </div>
                    <Icon className={styles.icon} name="nav_right" />
                </div>
                <div className={styles.tab} onClick={() => navigate(routes.settings_notifications)}>
                    <img src={notificationsIcon} alt="" />
                    <div className={styles.text_wrapper}>
                        <div className={styles.title}>{t('notification')}</div>
                        <div className={styles.description}>
                            Customize how you receive updates: choose which notifications to get and
                            how you'd like to receive them
                        </div>
                    </div>
                    <Icon className={styles.icon} name="nav_right" />
                </div>
                <div className={styles.tab} onClick={() => navigate(routes.settings_security)}>
                    <img src={securityIcon} alt="" />
                    <div className={styles.text_wrapper}>
                        <div className={styles.title}>Security</div>
                        <div className={styles.description}>
                            Update your password regularly and enable two-factor authentication to
                            protect your account
                        </div>
                    </div>
                    <Icon className={styles.icon} name="nav_right" />
                </div>
                <div className={styles.tab} onClick={() => navigate(routes.limits)}>
                    <img src={limits} alt="" />
                    <div className={styles.text_wrapper}>
                        <div className={styles.title}>Limits</div>
                        <div className={styles.description}>
                            View your daily, weekly, monthly, and per-transaction sending limits
                        </div>
                    </div>
                    <Icon className={styles.icon} name="nav_right" />
                </div>
            </div>
        </motion.div>
    );
};

export default SettingsLayout;
